import { render, staticRenderFns } from "./TableCellNumber.vue?vue&type=template&id=60804842&scoped=true&"
import script from "./TableCellNumber.vue?vue&type=script&lang=js&"
export * from "./TableCellNumber.vue?vue&type=script&lang=js&"
import style0 from "./TableCellNumber.vue?vue&type=style&index=0&id=60804842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60804842",
  null
  
)

export default component.exports